"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLocalCityRequest = void 0;
var GetLocalCityRequest = /** @class */ (function () {
    function GetLocalCityRequest() {
    }
    return GetLocalCityRequest;
}());
exports.GetLocalCityRequest = GetLocalCityRequest;
;
//# sourceMappingURL=getLocalCity.request.js.map